import {NgModule} from "@angular/core";
import {UserSelectionComponent} from "./user-selection.component";
import {FormsModule} from "@angular/forms";
import {BrowserModule} from "@angular/platform-browser";
import {PaginationModule} from "../pagination/pagination.module";
import {UserSelectionService} from "./user-selection.service";
import {HttpClientModule} from "@angular/common/http";
import {ErrorModule} from "../errors/error.module";

@NgModule({
  imports: [
    BrowserModule,
    FormsModule,
    PaginationModule,
    HttpClientModule,
    ErrorModule,
  ],
  providers: [UserSelectionService],
  declarations: [UserSelectionComponent],
  exports: [UserSelectionComponent],
})
export class UserSelectionModule {}
